import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useAgencyInfo } from "../../../context/agency";
import ModuleConnect from "../components/ModuleConnect";

const wrapperStyles = {
  position: "relative",
  width: "100%",
  height: "100vh",
};

const iframeStyles = {
  width: "100%",
  height: "100%",
  border: "none",
  display: "block",
};

const CustomValueForm = () => {
  const { companyId } = useParams();
  const [agency] = useAgencyInfo();
  const [iframeLoaded, setIframeLoaded] = useState(false);

  if (!agency?.modulesAuth) {
    return (
      <ModuleConnect
        icon="bi bi-input-cursor-text"
        title="Connect to Use Custom Value Form"
        description="To build and manage custom value forms across your sub-accounts, connect your GoHighLevel agency account so we can read and update custom values for you."
      />
    );
  }

  return (
    <div style={wrapperStyles}>
      <style>{`
        .cvf-loader-overlay {
          position: absolute;
          inset: 0;
          background: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 14px;
          z-index: 2;
          transition: opacity .3s ease;
        }
        .cvf-loader-overlay.hidden {
          opacity: 0;
          pointer-events: none;
        }
        .cvf-loader-icon {
          width: 56px;
          height: 56px;
          border-radius: 14px;
          background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
          color: #2563eb;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          box-shadow: inset 0 0 0 1px rgba(29,78,216,.12);
        }
        .cvf-spinner {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: 3px solid #e2e8f0;
          border-top-color: #2563eb;
          animation: cvf-spin .8s linear infinite;
        }
        @keyframes cvf-spin {
          to { transform: rotate(360deg); }
        }
        .cvf-loader-title {
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
        }
        .cvf-loader-hint {
          font-size: 12.5px;
          color: #64748b;
        }
      `}</style>

      <div className={`cvf-loader-overlay ${iframeLoaded ? "hidden" : ""}`}>
        <div className="cvf-loader-icon">
          <Icon icon="solar:clipboard-text-bold-duotone" />
        </div>
        <div className="cvf-spinner" />
        <div className="text-center">
          <div className="cvf-loader-title">Loading Custom Value Forms</div>
          <div className="cvf-loader-hint">This usually takes a moment…</div>
        </div>
      </div>

      <iframe
        src={`https://form.smartconnector.org/${companyId}/custom_value_form/list`}
        style={iframeStyles}
        allow="clipboard-read; clipboard-write"
        onLoad={() => setIframeLoaded(true)}
      ></iframe>
    </div>
  );
};

export default CustomValueForm;
